import { render, staticRenderFns } from "./daitou.vue?vue&type=template&id=7360d881&scoped=true"
import script from "./daitou.vue?vue&type=script&lang=js"
export * from "./daitou.vue?vue&type=script&lang=js"
import style0 from "./daitou.vue?vue&type=style&index=0&id=7360d881&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7360d881",
  null
  
)

export default component.exports